module.exports = __webpack_public_path__ + "static/kelsie-1-41d6f963892a6f8662356885e50775db.jpg";